import * as yup from "yup";

export const updateFabricationAndShipmentDateSchema = yup.object().shape({
  datetime: yup.date().required("Date and Time is required"),
});
